// Module
var code = "<div class=\"t-content t-popout c-popout u-flex\">\n    <div class=\"c-labeledBalance\" ng-bind=\"::context.title\">\n    </div>\n</div>";
// Exports
module.exports = code;